import React from 'react';
import { Headline, LinkButton } from '@sato/components';
import classNames from 'classnames';

import { LinkList } from '@/contentful/components';
import { StaticContentfulEntry } from '@/contentful/contentful.constants';
import { useContentfulEntry } from '@/contentful/hooks/useContentful';
import { IListedLinkList } from '@/contentful/types';

import { Link } from './common/Link';
import { SkeletonList } from './Skeleton/SkeletonList';

export type TipsProps = {
  listContentfulId: string;
  allTipsUrl: string;
};

type Props = TipsProps & {
  className?: string;
  buttonText: string;
  heading: string;
};

/** Used to show a list of tips and reminders for new or leaving residents (where to return keys, etc.) */
export const ResidentTipsList = ({
  className,
  listContentfulId,
  allTipsUrl,
  buttonText,
  heading,
}: Props) => {
  const { data, isLoading, isError } = useContentfulEntry<IListedLinkList>(
    listContentfulId as StaticContentfulEntry
  );

  if (isError) return null;

  return (
    <div
      className={classNames(
        'rounded bg-white px-3 pb-2 pt-4 text-center text-black shadow-lg lg:pt-5',
        className
      )}
    >
      <Headline level={3}>{heading}</Headline>

      <div className="mt-3 text-left">
        {isLoading ? (
          <SkeletonList itemClassName="h-8" className="gap-2" />
        ) : (
          data && <LinkList data={data} />
        )}
      </div>

      <LinkButton
        linkComponent={Link}
        to={allTipsUrl}
        variant="ghost"
        className="mx-auto mt-3"
        icon="arrowRight"
        iconPosition="right"
      >
        {buttonText}
      </LinkButton>
    </div>
  );
};
